import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';    
import { UsuarioGuard } from './guards/usuario.guard';
import { BrotherGuard } from './guards/brother.guard';
import { PagoGuard } from './guards/pago.guard';
import { DeudaGuard } from './guards/deuda.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  { path: 'login', loadChildren: './pages/login/login.module#LoginPageModule'},
  { path: 'vehicle', loadChildren: './pages/vehicle/vehicle.module#VehiclePageModule' },
  { path: 'user', loadChildren: './pages/user/user.module#UserPageModule', canActivate:[UsuarioGuard]},
  { path: 'changepass', loadChildren: './pages/changepass/changepass.module#ChangePassPageModule' },
  { path: 'edit-vehicle', loadChildren: './pages/vehicle/edit-vehicle/edit-vehicle.module#EditVehiclePageModule' },
  { path: 'hermano', loadChildren: './pages/brother/brother.module#BrotherPageModule',canActivate:[BrotherGuard] },
  { path: 'pago', loadChildren: './pages/pago/pago.module#PagoPageModule', canActivate:[PagoGuard]},
  { path: 'deuda', loadChildren: './pages/deuda/deuda.module#DeudaPageModule', canActivate:[DeudaGuard] },
  { path: 'paypal', loadChildren: './pages/paypal/paypal.module#PaypalPageModule' },
  { path: 'paypal-web', loadChildren: './pages/paypal-web/paypal-web.module#PaypalWebPageModule' },
  { path: 'insignias', loadChildren: './pages/insignias/insignias.module#InsigniasPageModule' },
  { path: 'papeletas', loadChildren: './pages/papeletas/papeletas.module#PapeletasPageModule' },
  { path: 'insignias-modal', loadChildren: './pages/insignias-modal/insignias-modal.module#InsigniasModalPageModule' },
  { path: 'papeletas-modal', loadChildren: './pages/papeletas-modal/papeletas-modal.module#PapeletasModalPageModule' },
  { path: 'sugerencias', loadChildren: './pages/sugerencias/sugerencias.module#SugerenciasPageModule' },
  { path: 'stripe', loadChildren: './pages/stripe/stripe.module#StripePageModule' },  { path: 'donativos', loadChildren: './pages/donativos/donativos.module#DonativosPageModule' }



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
